import { PAGE_TYPE } from "enums";
import { getLanguageValue } from "locales/i18n";
import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const UnSubscribeEmailDoneComponent = (props: any) => {
  const { email } = props;

  return (
    <main className="flex flex-col items-center justify-center min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          {getLanguageValue(PAGE_TYPE.COMMON, "unSubscribeEmailDone.txtResult")}
        </h2>
        <div className="bg-gray-50 p-4 rounded-lg mb-6">
          <p className="text-lg font-medium text-[#CF3688]">{email}</p>
        </div>
        <p className="text-sm text-gray-600 mb-6">
          이메일 수신 거부가 성공적으로 처리되었습니다. 더 이상 해당 이메일로 뉴스레터가 발송되지 않습니다.
        </p>
        <div className="border-t border-gray-200 pt-6">
          <p className="text-xs text-gray-500">
            문의사항이 있으시면 고객센터로 연락해 주세요.
          </p>
          <p className="text-xs text-gray-500">
            <a href="mailto:biz@theethru.com">biz@theethru.com</a>
          </p>
        </div>
      </div>
    </main>
  );
};
export default UnSubscribeEmailDoneComponent;
